import { motion, useReducedMotion } from "framer-motion";
import { Img } from "@/components/public/ui";
import { EASE } from "@/components/public/Reveal";
import { cn } from "@/lib/utils";

/*
  Page opening: the statement in type, then a photo on the left and a quiet card on the right with the
  short text, actions and one line of contact details. Nothing is written on top of the photo.
*/
export const Hero = ({ title, lead, actions, image, imageAlt = "", note, ratio = "aspect-[4/3] sm:aspect-[16/10]", className = "", titleClass = "", testid = "public-hero", children }) => {
  const reduce = useReducedMotion();
  const fade = (delay) => ({
    initial: reduce ? false : { opacity: 0, y: 14 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: EASE, delay },
  });
  return (
    <section className={cn("container-public pt-10 sm:pt-14 lg:pt-20", className)} data-testid={testid}>
      <motion.h1 className={cn("t-display max-w-[20ch]", titleClass)} data-testid={`${testid}-title`} {...fade(0)}>
        {title}
      </motion.h1>
      <motion.div className="mt-10 grid gap-4 sm:mt-14 lg:grid-cols-12 lg:gap-5" {...fade(0.12)}>
        <div className={cn("overflow-hidden rounded-2xl bg-muted lg:col-span-8", ratio)}>
          <Img src={image} alt={imageAlt} sizes="(min-width: 1024px) 66vw, 100vw" loading="eager" fetchPriority="high" className="img-premium h-full w-full object-cover" />
        </div>
        <div className="flex flex-col rounded-2xl bg-secondary p-6 sm:p-8 lg:col-span-4" data-testid={`${testid}-card`}>
          <div className="my-auto">
            {lead && <p className="text-[16.5px] leading-relaxed text-foreground/85 sm:text-[17px]">{lead}</p>}
            {actions && <div className="mt-7 flex flex-wrap items-center gap-3">{actions}</div>}
            {children}
          </div>
          {note && <p className="mt-8 text-[12.5px] leading-relaxed text-muted-foreground">{note}</p>}
        </div>
      </motion.div>
    </section>
  );
};
